import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Typography, makeStyles } from '@material-ui/core';
import AsyncListTooltip from '../asyncListTooltip';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  badge: {
    backgroundColor: primary.bluish8,
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    padding: spacing(0, 3),
    borderRadius: 40,
    height: 28,
  },
  icon: {
    marginLeft: spacing(1),
  },
}));

const AsyncListBadge = ({
  className = undefined,
  badgeClass = undefined,
  badgeIconClass = undefined,
  countClass = undefined,
  tooltipTitle,
  count = 0,
  items = [],
  icon: Icon,
  renderItem = () => {},
  checkIsClickable = () => true,
  shouldDisablePortal = true,
  onItemClick = () => {},
  getItems = () => {},
  ...rest
}) => {
  const classes = useStyles();
  const isEmpty = count === 0;

  return (
    <div className={className}>
      <AsyncListTooltip
        title={tooltipTitle}
        labelData={items}
        renderLabelItem={renderItem}
        shouldDisablePortal={shouldDisablePortal}
        isItemClickable={checkIsClickable}
        isTooltipDisabled={isEmpty}
        isDisabled={isEmpty}
        onItemClickHandler={onItemClick}
        getLabelData={getItems}
        {...rest}
      >
        <div className={classNames(classes.badge, badgeClass)}>
          <Typography className={countClass} variant="subtitle1">
            {count}
          </Typography>
          <Icon className={classNames(classes.icon, badgeIconClass)} />
        </div>
      </AsyncListTooltip>
    </div>
  );
};

AsyncListBadge.propTypes = {
  className: PropTypes.string,
  badgeClass: PropTypes.string,
  badgeIconClass: PropTypes.string,
  countClass: PropTypes.string,
  count: PropTypes.number,
  icon: PropTypes.object.isRequired,
  checkIsClickable: PropTypes.func,
  tooltipTitle: PropTypes.string.isRequired,
  shouldDisablePortal: PropTypes.bool,
  renderItem: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.object),
  getItems: PropTypes.func,
  onItemClick: PropTypes.func,
};

export default AsyncListBadge;
